import Vue from 'vue';

export default {
  state: {
    currentProject: {
      content: '',
    },
    projectsList: [],
    projectCategoriesList: [],
  },
  mutations: {
    setCurrentProject(state, data) {
      state.currentProject = data;
    },
    setProjectsList(state, data) {
      state.projectsList = data;
    },
    setProjectCategoriesList(state, data) {
      state.projectCategoriesList = data;
    },
  },
  actions: {
    getProjectsList(store) {
      const path = 'projects?_sort=year:desc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setProjectsList', resp.data);
        return resp.data;
      });
    },
    getProjectCategoriesList(store) {
      const path = 'project-categories';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setProjectCategoriesList', resp.data);
        return resp.data;
      });
    },
    getProjectByID(store, ID) {
      const path = 'projects';
      return Vue.prototype.$axios.get(`${path}/${ID}`).then((resp) => {
        store.commit('setCurrentProject', resp.data);
        return resp.data;
      });
    },
  },
};
